import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { doListCustomer, doCreateCustomer, doGetCustomerDetail, doUpdateCustomer, doDeleteCustomer } from "services/customer.service";

export const onGetCustomerList = createAsyncThunk("customers/onGetCustomerList", async () => {
  try {
    const response: any = await doListCustomer(0);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const onGetCustomer = createAsyncThunk("customers/onGetCustomer", async (userId: string) => {
  try {
    const response: any = await doGetCustomerDetail(userId);
    return response;
  } catch (error) {
    return error;
  }
});

export const onAddCustomer = createAsyncThunk("customers/onAddCustomer", async (params: any) => {
  try {
    const response = doCreateCustomer(params);
    const data = await response;
    toast.success("Customer Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Customer Added Failed", { autoClose: 2000 });
    return error;
  }
});

export const onUpdateCustomer = createAsyncThunk("customers/onUpdateCustomer", async (params: any) => {
  try {
    const response = doUpdateCustomer(params);
    const data = await response;
    toast.success("Customer updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Customer updated Failed", { autoClose: 2000 });
    return error;
  }
});

export const onDeleteCustomer = createAsyncThunk("customers/onDeleteCustomer", async (userId: string) => {
  try {
    const response = doDeleteCustomer(userId);
    toast.success("Customer deleted Successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error("Customer deleted Failed", { autoClose: 2000 });
    return error;
  }
});
